import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";
import ReactTooltip from "react-tooltip";
import { FlexBox, MagicBox, useIsMobile, useToasts } from "@brg/ui";
import { Tag } from "@brg/api";
import {
  TagsSearchInput,
  TagsSearchInputWrapper,
  TagsSearchModalContainer,
  TagsSearchModalWrapper,
  TagsSearchSelection,
  TagsSearchTitle,
  TagsSelectedTitle,
  TagsSearchScrollWrapper,
  InputSmallCaption,
  SearchIconWrapper,
} from "./styles.mobile";
import { Icon } from "@brg/icons-next";
import { BTag, BTagsGrid } from "../../../core/components";
import { bTag, modalControllerActions, useModal } from "../../../core";
import CloseIcon from "../../icons/CloseIcon";
import {EmptyTextWrapper} from "./FoundTags";
import { debounceEvent } from "shared/utils/debounce";
import { useDispatch, useSelector } from "react-redux";
import { TagsActions, TagsSelector } from "shared/reducers/Tags";
import { CreateLinkTo } from "shared/constants/linkTo";
import { AGEYTOMESH_TAG_ID } from "shared/constants/misc";
import { useHistory, useLocation } from "react-router-dom";
import { CategoryHeader } from "./CategoryHeader";
import { SearchResults } from "./SearchResults";
import {
  LABORATORY_PARAM,
  APPROVED_HSEDESIGN_PARAM,
} from "./selectTagsModal";
import { AppTester } from 'supporting';
import { useContextsTabs } from "shared/hooks/useContextsTabs";
import { isRequired } from "./support/isRequired";
import { setIsOpen } from "shared/reducers/OpenModal";
import {removeUndefined} from "../../helpers/removeUndefined";
import {LoaderSpinner} from "../artzLegalsModal/LoaderAnimation";
import {useGetApiTags} from "../../hooks/api/useGetApiTags";
import {bProfile} from "../../../core/utils/bProfile";
import {useProfile} from "@brg/auth";
import {TagsAvailableTitle} from "./styles";
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { SelectTagsModalProps } from "./types";


const CITIES_ID = 'dc762a78dac54369b91542bcbe86bb2a';

const AlignedBTagsGrid = styled(MagicBox)`
  ${BTagsGrid} {
    // div:first-child {
    //   margin-left: 90px;
    // }
  }
`

export interface IGrouppedTags<T> {
  isEducationTag?: boolean;
  categoryId?: string;
  childrens?: T;
  found?: number;
  position?: number;
  groupId?: string | null;
  categoryTitle?: string;
  isTagCategory?: boolean;
  isSearchButton?: boolean;
  isMoreButton?: boolean;
  isEmptyCategory?: boolean;
  ctx?: string[];
  hideGlobalSearchBar?: boolean;
}

export enum LOAD_TYPE {
  initial = 1,
  update = 2,
  tagSearch = 3,
  tagsSearchIntoCategory = 4,
  tagSearchIntoTag = 5,
  tagSearchGlobal = 6,
  tagsFetchMore = 7,
  tagsFetchMoreLarge = 8,
  tagsFetchMoreLargeChild = 9,
}

export interface TagGroupItem {
  categoryId: string;
  categoryTitle: string;
  tags: Tag[];
  found: number;
  position: number;
  isMobileMenu?: boolean;
  viewAllTags?: boolean;
}

export const SelectTagsModalMobile: FC<SelectTagsModalProps> = (props) => {
  const {
    value,
    onChange,
    max,
    ctx,
    onClose,
    maxEducationalTags,
    maxProjectTags,
    maxPlacesTags,
    maxTeamsTags,
    isCreateLocation,
    protectedTags = [],
    mode,
    requiredTags,
    isMobileMenu,
    isEdit,
    educational,
    global: globalProp,
    hasEduTags,
    viewAllTags,
    isTagEditor,
    editableTags = []
  } = props;

  const modal = useModal();
  const valueRef = useRef<Tag[]>([]);
  const mainSearchRef = useRef<any>(null);
  const toasts = useToasts();
  const dispatch = useDispatch();
  const history = useHistory();
  const isMobile = useIsMobile();
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const [time, setTime] = useState(Date.now());
  const [showAllTagsInGroup, setShowAllTagsInGroup] = useState(false);
  const location = useLocation();
  const isProjectEdit = location.pathname.startsWith("/edit");
  const isTagsSearchPage = location.pathname.startsWith('/tags');
  const isHSEDesign = AppTester.isHSEDesign();
  const isSuperPuper = AppTester.isSuperPuper()
  const isStartHSE = AppTester.isStartHSE();
  const profile = useProfile()
  const isModer = bProfile.isModer(profile) || bProfile.isSuperModer(profile)
  const global = useMemo(() => ((Boolean(isTagEditor && !isModer && !!editableTags?.length)) || globalProp),
      [isModer, globalProp, isTagEditor])

  const isLaboratoryPage =
    window?.location.pathname.startsWith("/laboratory") ||
    Boolean(
      window.location.href
        .split("?")
        .find((l) => l === LABORATORY_PARAM.slice(1))
    );

  const {
    searchText, 
    headerTag: { current: headerTag },
    selectedTags: innerValue,
    selectedTagsIndex,
  } = useSelector(TagsSelector);

      //Костыль чтобы убрать образовательную категорию и образов теги взависимости от открытой модалки
      const shouldVisibleEducationCategory = useMemo(
        () => (
          isProjectEdit && 
        ctx && (ctx?.includes('onlines_required_category') || requiredTags ||
        ctx?.includes('required_category'))), [isProjectEdit, ctx]
    )

  const shouldMoveToTop = useMemo(() => (!isProjectEdit), [isProjectEdit]);

  const optionTagsFilter = useMemo(() => ({
    isModeEditing: isEdit || false,
    ...(isStartHSE && isTagsSearchPage ? {
      isEducation: true,
    } : educational !== undefined ? {
      isEducation: educational,
    } : {}),
    ...(isCreateLocation ? { 
      entityTypes: [], 
      groupIds: [CITIES_ID]
    } : ctx ? {
      entityTypes: ctx,
    } : {}),
    ...(isTagEditor && !isModer && editableTags ? {
      tagIds: editableTags || [],
    } : {}),
    ...(global ? {
      isHeaderIgnored: global,
    } : {}),
    ...(hasEduTags !== undefined && !(isStartHSE && isTagsSearchPage) ? {
      hasEduTags: hasEduTags,
    } : {})
  }), [isModer, isEdit, educational, global, ctx, hasEduTags, isTagEditor, isStartHSE, isTagsSearchPage])

  const filter = useMemo(() => {
    if (headerTag) {
      //@ts-ignore
      const { categoryId, tagId } = headerTag;
      const groupId = categoryId || tagId;
      const result = {
        groupIds: [groupId],
        ...(headerTag.level === 2 ? {} : { contextIgnored: true }),
        status: [0],
        lang: i18n.language,
        ...optionTagsFilter,
        ...(showAllTagsInGroup ? { isHeaderIgnored: true } : {}),
        ...(searchText ? {
          search: [searchText],
          ...(hasEduTags !== undefined ? {isEducation: undefined} : {})
        } : {}),
      };
      return result;
    }
    if (searchText) {
      return {
        search: [searchText],
        status: [0],
        lang: i18n.language,
        ...optionTagsFilter,
        ...(hasEduTags !== undefined ? {isEducation: undefined} : {})
      };
    }
    return {
      lang: i18n.language,
      status: [0],
      ...optionTagsFilter
    }
  }, [hasEduTags, headerTag, searchText, i18n.language, optionTagsFilter, showAllTagsInGroup]);

  const initialAllTagsFilter = useMemo(() => ({
    status: 0,
    level: 1,
    isHeaderIgnored: true,
    includeCount: true,
    limit: 100,
    page: 1 
  }), [])

  const requestDisabled = viewAllTags;

  const [tagsEn, loadEn] = useGetApiTags({
    ...removeUndefined(filter),
    lang: 'en'
  }, 'en', time, requestDisabled);
  const [tagsRu, loadRu] = useGetApiTags({
    ...removeUndefined(filter),
    lang: 'ru'
  }, 'ru', time, requestDisabled);

    const [tagsAllEn, loadAllEn] = useGetApiTags({ ...initialAllTagsFilter }, 'en', time, !viewAllTags);
    const [tagsAllRu, loadAllRu] = useGetApiTags({ ...initialAllTagsFilter }, 'ru', time, !viewAllTags);

    const load = viewAllTags ? (loadAllEn || loadAllRu) : (loadEn || loadRu);

    const tags = useMemo(() => {
      if (i18n.language === 'ru') {
        //@ts-ignore
        return viewAllTags ? tagsAllRu?.data : tagsRu;
      }
      //@ts-ignore
      return viewAllTags ? tagsAllEn?.data : tagsEn;
    }, [i18n.language, tagsEn, tagsAllRu, tagsAllEn, tagsRu, viewAllTags]);

  const ungrouped: any[] = useMemo(
    () => [
      {
        categoryId: "all",
        categoryTitle: "All",
        tags: (tags ?? []),
        found: 0,
        position: 2,
      }
    ],
    [tags],
  );

  const tagMap = useMemo(() => {
    if (viewAllTags) {
      return tags;
    }
    if (headerTag) {
      return tags.reduce((result: any, tag: any) => {
        //@ts-ignore
        const innerTags = tag.additionalTags.reduce((res, innerTag) => {
          if (innerTag.level === 1) {
            return {
              ...res,
              [innerTag.tagId]: innerTag.additionalTags,
            };
          }
          return res;
        }, {});
        return {
          ...result,
          ...innerTags,
          [tag.tagId]: tag.additionalTags,
        };
      }, {});
    }
    return {};
  }, [tags, headerTag, viewAllTags]);

  useEffect(() => {
    setTime(Date.now());

  }, [filter, searchText, headerTag, showAllTagsInGroup]);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }, [])

  const setInnerValue = (value: Tag[]) => {
    dispatch(TagsActions.setSelectedTags(value));
  };

  useEffect(() => {
    setInnerValue(value ?? []);
    dispatch(TagsActions.setOnSave((val: Tag[]) => {
      if (onChange) onChange(val);
      valueRef.current = val;
    }))
  }, []);

  const onModalClose = useCallback(([firstTag]: Tag[]): void => {
    dispatch(TagsActions.setSearchText(''))
    dispatch(TagsActions.setHeaderTag({
      current: null,
      parent: null,
    }))
    if (firstTag) {
      if (firstTag.tagId === AGEYTOMESH_TAG_ID) {
        window.open("https://ageytomesh.com");
      } else {
        history.push(
          isLaboratoryPage ?
            CreateLinkTo.tag(firstTag?.tagId) + LABORATORY_PARAM + '&' + APPROVED_HSEDESIGN_PARAM?.slice(1) :
            isHSEDesign ?
              CreateLinkTo.tag(firstTag?.tagId) + APPROVED_HSEDESIGN_PARAM :
              CreateLinkTo.tag(firstTag?.tagId)
        )
      }
      onClose?.([firstTag]);
    }
  }, [isLaboratoryPage, isHSEDesign]);

  const checkTagsCount = useCallback(() => {
    const placesTagCount = innerValue?.filter((i) => i?.entityTypes?.includes('places') || i?.entityTypes?.includes('geotag') || i?.entityTypes?.includes('cities'))?.length;
    const currentTagsCount = innerValue?.length - placesTagCount;

    if (maxTeamsTags && (currentTagsCount > maxTeamsTags)) {
      toasts.error(t('project_edit.max_team_project_tags_error', {count: maxTeamsTags}));
      setInnerValue(innerValue.slice(0, innerValue?.length - 1))
      return;
    }

    if (maxProjectTags && (currentTagsCount > maxProjectTags)) {
        toasts.error(t('project_edit.max_project_tags_error', {count: maxProjectTags}));
        setInnerValue(innerValue.slice(0, innerValue?.length - 1))
        return;
    }
    if (maxPlacesTags && (placesTagCount > maxPlacesTags)) {
        toasts.error(t('project_edit.max_places_tags_error', {count: maxPlacesTags}));
        setInnerValue(innerValue.slice(0, innerValue?.length - 1))
        return;
    }

  }, [maxProjectTags, maxPlacesTags, toasts, modal, t])

  useEffect(() => {
    if (shouldMoveToTop) {
      window.scrollTo({ top: 0 });
    }
    window.document.body.style.overflow = "hidden";
    return () => {
      window.document.body.style.overflow = '';
      if (mode === 'link') {
        onModalClose(valueRef.current);
      }
      dispatch(TagsActions.setSearchText(''))
      dispatch(TagsActions.setHeaderTag({
        current: null,
        parent: null,
      }))
      dispatch(TagsActions.setSelectedTags([]))
      dispatch(TagsActions.setOnSave(null))
    };
  }, [onClose, shouldMoveToTop, mode]);

  useEffect(() => {
    checkTagsCount();
}, [innerValue])

  useEffect(() => {
    if (innerValue && !!innerValue.length && mode === 'link') {
      onModalClose([innerValue[0]])
      dispatch(modalControllerActions.hideModal({}));
    }
  }, [innerValue, onModalClose]);

  useEffect(() => {
    if (mainSearchRef && !isMobile) {
        mainSearchRef.current?.focus()
    }
}, [mainSearchRef])

  const onInputText = (e: any) => {
    const str = e.target.value.trim();
    str?.length > 1 && dispatch(TagsActions.setSearchText(str));
    str?.length === 0 && dispatch(TagsActions.setSearchText(''));
  };

  const tagsScrollRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!tagsScrollRef.current) return;
    tagsScrollRef?.current?.scrollTo(0, 0)
  }, [headerTag, tagsScrollRef])

  const onTagSelect = (tag: any) => {
    const selected = selectedTagsIndex[tag.tagId];
    let v = innerValue;
    if (isTagEditor && !editableTags.includes(tag.tagId) && !(bProfile.isModer(profile) || bProfile.isSuperModer(profile))) {
      return;
    }
    if (!selected) {
      if (tag.level === 2 && isProjectEdit) {
        dispatch(TagsActions.setHeaderTag({ current: tag }));
        return;
      }
      const educationalTags = innerValue.filter(({ isEducationTag }: any) => isEducationTag);
      if (maxEducationalTags !== undefined && tag?.isEducationTag && educationalTags?.length + 1 > maxEducationalTags) {
        toasts.error(t('project_edit.max_required_tags_error'))
      } else {
        v = mode === 'link' || (max && innerValue?.length + 1 > max) ? [tag] : [...innerValue, tag];
      }
    } else if (protectedTags.includes(tag?.tagId)) {
      toasts.error("Это обязательный тег");
      return;
    } else {
      v = innerValue.filter((t) => t.tagId !== tag.tagId);
    }
    setInnerValue(v);
    
    if(tag.level === 2 && !isProjectEdit){
      dispatch(setIsOpen(true));
    }
  };

  const tagSearchSelection = (
    <TagsSearchSelection>
      <TagsSelectedTitle
        style={{ placeItems: 'center', whiteSpace: 'nowrap', marginBottom: 10 }}
      >
        {(!!innerValue.length && mode !== 'link') ? (isTagEditor ? `${t('tags_in_project')}:` : `${t('tags_modal.selected_tags')}:`) : t('tags_modal.select_tags')}
      </TagsSelectedTitle>
      {!!innerValue.length && (
        <AlignedBTagsGrid offsetTop={0}>
          <BTagsGridNew >
            {mode !== 'link' && innerValue.map((v: any) => (
              <BTag
                  tag={v}
                removable={true}
                key={v.tagId}
                // educational={v.isEducationTag}
                educational={isRequired(v)}
                //organization={isRequired(v, organizationEntity.tagIds, true)}
                organization={v?.isTeamTag}
                  showRemoveIcon={!(isTagEditor && !editableTags.includes(v.tagId) && !(bProfile.isModer(profile) || bProfile.isSuperModer(profile)))}
                  // @ts-ignore
                  disabled={isTagEditor && !editableTags.includes(v.tagId) && !(bProfile.isModer(profile) || bProfile.isSuperModer(profile))}
                  onIconClick={() => onTagSelect(v)}
              >
                {bTag.title(v)}
              </BTag>
            ))}
          </BTagsGridNew>
        </AlignedBTagsGrid>
      )}
    </TagsSearchSelection>
  );

  const getGrouping = () => {
    if (viewAllTags) {
      return 1;
    }
    const isSingleTag = tags?.length === 1;
    if (headerTag || isSingleTag) {
      return searchText ? 3 : 2;
    }
    if (!headerTag && searchText) {
      return 3;
    }
    return 1;
  };

  const displayedTags = useMemo(() => {
    if (viewAllTags) {
      return tags;
    }
    if (headerTag && !searchText) {
      return [
        {
          ...headerTag,
          additionalTags: tagMap[headerTag.tagId] || [],
        },
      ];
    }
    if (headerTag && searchText && tags.length) {
      return headerTag.level === 2 ? [tags[0]] : [tags[0]?.additionalTags?.[0]];
    }
    return tags.filter((tag: any) => !!tag?.additionalTags?.length);
  }, [tags, headerTag, viewAllTags, searchText, ungrouped, tagMap]);

  //Костыль чтобы убрать образовательную категорию и образов теги взависимости от открытой модалки
  const filteredTags = (arr: any[]) => {
      return arr;
  }

  const handleMoreClick = () => {
    setShowAllTagsInGroup(true);
  };

  const SearchResultsComponent = useMemo(() => <SearchResults
      tags={filteredTags(displayedTags)}
      grouping={getGrouping()}
      onTagSelect={onTagSelect}
      shouldVisibleEducationCategory={shouldVisibleEducationCategory}
      isMobileMenu={isMobileMenu}
      viewAllTags={viewAllTags}
      visible={!load}
      isEdit={isEdit}
      onMoreClick={handleMoreClick}
      showAllTagsInGroup={showAllTagsInGroup}
  >
    {!isMobileMenu && tagSearchSelection}
    {isTagEditor &&
        <TagsAvailableTitle
            style={{ display: 'inline-flex', placeItems: 'center', whiteSpace: 'nowrap' }}
        >
          {t('available_tags_in_project')}
        </TagsAvailableTitle>}
  </SearchResults>, [t, isTagEditor, isMobileMenu, tagSearchSelection, load, shouldVisibleEducationCategory, viewAllTags, onTagSelect, getGrouping, displayedTags, showAllTagsInGroup])
  return (
    <TagsSearchModalWrapper isMobileMenu={isMobileMenu}>
      <TagsSearchScrollWrapper ref={tagsScrollRef}>
      <TagsSearchModalContainer isMobileMenu={isMobileMenu}>
        {headerTag && <CategoryHeader headerTag={headerTag}/>}
        {!headerTag && !isMobileMenu && (
          <TagsSearchTitle color={theme.tagSearch.titleColor}>
            {t(isTagEditor ? "tag_editor" : max === 1 ? "select_single" : "select")}
            {isSuperPuper && <CloseIcon onClick={() => modal.hide()}/>}
          </TagsSearchTitle>
        )}
        <TagsSearchInputWrapper offsetTop={20} isMobileMenu={isMobileMenu}>
          <SearchIconWrapper isMobileMenu={isMobileMenu}>
            <Icon.Search24 />
          </SearchIconWrapper>
          <TagsSearchInput
            ref={mainSearchRef}
            onInput={debounceEvent(onInputText, 1000)}
            placeholder={t(isMobile ? "tags_modal.search_mobile" : "search")}
          />
        </TagsSearchInputWrapper>
        {isMobileMenu && (
          <InputSmallCaption>{t('select_tag_list')}</InputSmallCaption>
        )}
        {load && <EmptyTextWrapper directionMobile='column' gy={24}  width="100vw" align="center" justify="center" isMobileMenu={isMobileMenu}>
          <LoaderSpinner color={theme.selectContextModal.loaderText} text={t('project_edit.modal.load_msg_tag')}/>
        </EmptyTextWrapper>}

        {SearchResultsComponent}
      </TagsSearchModalContainer>
      </TagsSearchScrollWrapper>
      <ReactTooltip />
    </TagsSearchModalWrapper>
  );
};
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";
import ReactTooltip from "react-tooltip";
import { FlexBox, MagicBox, useIsMobile, useToasts } from "@brg/ui";
import { Tag } from "@brg/api";
import {
  TagsSearchInput,
  TagsSearchInputWrapper,
  TagsSearchModalContainer,
  TagsSearchModalWrapper,
  TagsSearchSelection,
  TagsSearchTitle,
  TagsSelectedTitle,
  TagsSearchScrollWrapper,
  InputSmallCaption,
  SearchIconWrapper,
} from "./styles.mobile";
import { Icon } from "@brg/icons-next";
import { BTag, BTagsGrid } from "../../../core/components";
import { bTag, modalControllerActions, useModal } from "../../../core";
import CloseIcon from "../../icons/CloseIcon";
import {EmptyTextWrapper} from "./FoundTags";
import { debounceEvent } from "shared/utils/debounce";
import { useDispatch, useSelector } from "react-redux";
import { TagsActions, TagsSelector } from "shared/reducers/Tags";
import { CreateLinkTo } from "shared/constants/linkTo";
import { AGEYTOMESH_TAG_ID } from "shared/constants/misc";
import { useHistory, useLocation } from "react-router-dom";
import { CategoryHeader } from "./CategoryHeader";
import { SearchResults } from "./SearchResults";
import {
  LABORATORY_PARAM,
  APPROVED_HSEDESIGN_PARAM,
} from "./selectTagsModal";
import { AppTester } from 'supporting';
import { useContextsTabs } from "shared/hooks/useContextsTabs";
import { isRequired } from "./support/isRequired";
import { setIsOpen } from "shared/reducers/OpenModal";
import {removeUndefined} from "../../helpers/removeUndefined";
import {LoaderSpinner} from "../artzLegalsModal/LoaderAnimation";
import {useGetApiTags} from "../../hooks/api/useGetApiTags";
import {bProfile} from "../../../core/utils/bProfile";
import {useProfile} from "@brg/auth";
import {TagsAvailableTitle} from "./styles";
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { SelectTagsModalProps } from "./types";


const CITIES_ID = 'dc762a78dac54369b91542bcbe86bb2a';

const AlignedBTagsGrid = styled(MagicBox)`
  ${BTagsGrid} {
    // div:first-child {
    //   margin-left: 90px;
    // }
  }
`

export interface IGrouppedTags<T> {
  isEducationTag?: boolean;
  categoryId?: string;
  childrens?: T;
  found?: number;
  position?: number;
  groupId?: string | null;
  categoryTitle?: string;
  isTagCategory?: boolean;
  isSearchButton?: boolean;
  isMoreButton?: boolean;
  isEmptyCategory?: boolean;
  ctx?: string[];
  hideGlobalSearchBar?: boolean;
}

export enum LOAD_TYPE {
  initial = 1,
  update = 2,
  tagSearch = 3,
  tagsSearchIntoCategory = 4,
  tagSearchIntoTag = 5,
  tagSearchGlobal = 6,
  tagsFetchMore = 7,
  tagsFetchMoreLarge = 8,
  tagsFetchMoreLargeChild = 9,
}

export interface TagGroupItem {
  categoryId: string;
  categoryTitle: string;
  tags: Tag[];
  found: number;
  position: number;
  isMobileMenu?: boolean;
  viewAllTags?: boolean;
}

export const SelectTagsModalMobile: FC<SelectTagsModalProps> = (props) => {
  const {
    value,
    onChange,
    max,
    ctx,
    onClose,
    maxEducationalTags,
    maxProjectTags,
    maxPlacesTags,
    maxTeamsTags,
    isCreateLocation,
    protectedTags = [],
    mode,
    requiredTags,
    isMobileMenu,
    isEdit,
    educational,
    global: globalProp,
    hasEduTags,
    viewAllTags,
    isTagEditor,
    editableTags = []
  } = props;

  const modal = useModal();
  const valueRef = useRef<Tag[]>([]);
  const mainSearchRef = useRef<any>(null);
  const toasts = useToasts();
  const dispatch = useDispatch();
  const history = useHistory();
  const isMobile = useIsMobile();
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const [time, setTime] = useState(Date.now());
  const [showAllTagsInGroup, setShowAllTagsInGroup] = useState(false);
  const location = useLocation();
  const isProjectEdit = location.pathname.startsWith("/edit");
  const isTagsSearchPage = location.pathname.startsWith('/tags');
  const isHSEDesign = AppTester.isHSEDesign();
  const isSuperPuper = AppTester.isSuperPuper()
  const isStartHSE = AppTester.isStartHSE();
  const profile = useProfile()
  const isModer = bProfile.isModer(profile) || bProfile.isSuperModer(profile)
  const global = useMemo(() => ((Boolean(isTagEditor && !isModer && !!editableTags?.length)) || globalProp),
      [isModer, globalProp, isTagEditor])

  const isLaboratoryPage =
    window?.location.pathname.startsWith("/laboratory") ||
    Boolean(
      window.location.href
        .split("?")
        .find((l) => l === LABORATORY_PARAM.slice(1))
    );

  const {
    searchText, 
    headerTag: { current: headerTag },
    selectedTags: innerValue,
    selectedTagsIndex,
  } = useSelector(TagsSelector);

      //Костыль чтобы убрать образовательную категорию и образов теги взависимости от открытой модалки
      const shouldVisibleEducationCategory = useMemo(
        () => (
          isProjectEdit && 
        ctx && (ctx?.includes('onlines_required_category') || requiredTags ||
        ctx?.includes('required_category'))), [isProjectEdit, ctx]
    )

  const shouldMoveToTop = useMemo(() => (!isProjectEdit), [isProjectEdit]);

  const optionTagsFilter = useMemo(() => ({
    isModeEditing: isEdit || false,
    ...(isStartHSE && isTagsSearchPage ? {
      isEducation: true,
    } : educational !== undefined ? {
      isEducation: educational,
    } : {}),
    ...(isCreateLocation ? { 
      entityTypes: [], 
      groupIds: [CITIES_ID]
    } : ctx ? {
      entityTypes: ctx,
    } : {}),
    ...(isTagEditor && !isModer && editableTags ? {
      tagIds: editableTags || [],
    } : {}),
    ...(global ? {
      isHeaderIgnored: global,
    } : {}),
    ...(hasEduTags !== undefined && !(isStartHSE && isTagsSearchPage) ? {
      hasEduTags: hasEduTags,
    } : {})
  }), [isModer, isEdit, educational, global, ctx, hasEduTags, isTagEditor, isStartHSE, isTagsSearchPage])

  const filter = useMemo(() => {
    if (headerTag) {
      //@ts-ignore
      const { categoryId, tagId } = headerTag;
      const groupId = categoryId || tagId;
      const result = {
        groupIds: [groupId],
        ...(headerTag.level === 2 ? {} : { contextIgnored: true }),
        status: [0],
        lang: i18n.language,
        ...optionTagsFilter,
        ...(showAllTagsInGroup ? { isHeaderIgnored: true } : {}),
        ...(searchText ? {
          search: [searchText],
          ...(hasEduTags !== undefined ? {isEducation: undefined} : {})
        } : {}),
      };
      return result;
    }
    if (searchText) {
      return {
        search: [searchText],
        status: [0],
        lang: i18n.language,
        ...optionTagsFilter,
        ...(hasEduTags !== undefined ? {isEducation: undefined} : {})
      };
    }
    return {
      lang: i18n.language,
      status: [0],
      ...optionTagsFilter
    }
  }, [hasEduTags, headerTag, searchText, i18n.language, optionTagsFilter, showAllTagsInGroup]);

  const initialAllTagsFilter = useMemo(() => ({
    status: 0,
    level: 1,
    isHeaderIgnored: true,
    includeCount: true,
    limit: 100,
    page: 1 
  }), [])

  const requestDisabled = viewAllTags;

  const [tagsEn, loadEn] = useGetApiTags({
    ...removeUndefined(filter),
    lang: 'en'
  }, 'en', time, requestDisabled);
  const [tagsRu, loadRu] = useGetApiTags({
    ...removeUndefined(filter),
    lang: 'ru'
  }, 'ru', time, requestDisabled);

    const [tagsAllEn, loadAllEn] = useGetApiTags({ ...initialAllTagsFilter }, 'en', time, !viewAllTags);
    const [tagsAllRu, loadAllRu] = useGetApiTags({ ...initialAllTagsFilter }, 'ru', time, !viewAllTags);

    const load = viewAllTags ? (loadAllEn || loadAllRu) : (loadEn || loadRu);

    const tags = useMemo(() => {
      if (i18n.language === 'ru') {
        //@ts-ignore
        return viewAllTags ? tagsAllRu?.data : tagsRu;
      }
      //@ts-ignore
      return viewAllTags ? tagsAllEn?.data : tagsEn;
    }, [i18n.language, tagsEn, tagsAllRu, tagsAllEn, tagsRu, viewAllTags]);

  const ungrouped: any[] = useMemo(
    () => [
      {
        categoryId: "all",
        categoryTitle: "All",
        tags: (tags ?? []),
        found: 0,
        position: 2,
      }
    ],
    [tags],
  );

  const tagMap = useMemo(() => {
    if (viewAllTags) {
      return tags;
    }
    if (headerTag) {
      return tags.reduce((result: any, tag: any) => {
        //@ts-ignore
        const innerTags = tag.additionalTags.reduce((res, innerTag) => {
          if (innerTag.level === 1) {
            return {
              ...res,
              [innerTag.tagId]: innerTag.additionalTags,
            };
          }
          return res;
        }, {});
        return {
          ...result,
          ...innerTags,
          [tag.tagId]: tag.additionalTags,
        };
      }, {});
    }
    return {};
  }, [tags, headerTag, viewAllTags]);

  useEffect(() => {
    setTime(Date.now());

  }, [filter, searchText, headerTag, showAllTagsInGroup]);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }, [])

  const setInnerValue = (value: Tag[]) => {
    dispatch(TagsActions.setSelectedTags(value));
  };

  useEffect(() => {
    setInnerValue(value ?? []);
    dispatch(TagsActions.setOnSave((val: Tag[]) => {
      if (onChange) onChange(val);
      valueRef.current = val;
    }))
  }, []);

  const onModalClose = useCallback(([firstTag]: Tag[]): void => {
    dispatch(TagsActions.setSearchText(''))
    dispatch(TagsActions.setHeaderTag({
      current: null,
      parent: null,
    }))
    if (firstTag) {
      if (firstTag.tagId === AGEYTOMESH_TAG_ID) {
        window.open("https://ageytomesh.com");
      } else {
        history.push(
          isLaboratoryPage ?
            CreateLinkTo.tag(firstTag?.tagId) + LABORATORY_PARAM + '&' + APPROVED_HSEDESIGN_PARAM?.slice(1) :
            isHSEDesign ?
              CreateLinkTo.tag(firstTag?.tagId) + APPROVED_HSEDESIGN_PARAM :
              CreateLinkTo.tag(firstTag?.tagId)
        )
      }
      onClose?.([firstTag]);
    }
  }, [isLaboratoryPage, isHSEDesign]);

  const checkTagsCount = useCallback(() => {
    const placesTagCount = innerValue?.filter((i) => i?.entityTypes?.includes('places') || i?.entityTypes?.includes('geotag') || i?.entityTypes?.includes('cities'))?.length;
    const currentTagsCount = innerValue?.length - placesTagCount;

    if (maxTeamsTags && (currentTagsCount > maxTeamsTags)) {
      toasts.error(t('project_edit.max_team_project_tags_error', {count: maxTeamsTags}));
      setInnerValue(innerValue.slice(0, innerValue?.length - 1))
      return;
    }

    if (maxProjectTags && (currentTagsCount > maxProjectTags)) {
        toasts.error(t('project_edit.max_project_tags_error', {count: maxProjectTags}));
        setInnerValue(innerValue.slice(0, innerValue?.length - 1))
        return;
    }
    if (maxPlacesTags && (placesTagCount > maxPlacesTags)) {
        toasts.error(t('project_edit.max_places_tags_error', {count: maxPlacesTags}));
        setInnerValue(innerValue.slice(0, innerValue?.length - 1))
        return;
    }

  }, [maxProjectTags, maxPlacesTags, toasts, modal, t])

  useEffect(() => {
    if (shouldMoveToTop) {
      window.scrollTo({ top: 0 });
    }
    window.document.body.style.overflow = "hidden";
    return () => {
      window.document.body.style.overflow = '';
      if (mode === 'link') {
        onModalClose(valueRef.current);
      }
      dispatch(TagsActions.setSearchText(''))
      dispatch(TagsActions.setHeaderTag({
        current: null,
        parent: null,
      }))
      dispatch(TagsActions.setSelectedTags([]))
      dispatch(TagsActions.setOnSave(null))
    };
  }, [onClose, shouldMoveToTop, mode]);

  useEffect(() => {
    checkTagsCount();
}, [innerValue])

  useEffect(() => {
    if (innerValue && !!innerValue.length && mode === 'link') {
      onModalClose([innerValue[0]])
      dispatch(modalControllerActions.hideModal({}));
    }
  }, [innerValue, onModalClose]);

  useEffect(() => {
    if (mainSearchRef && !isMobile) {
        mainSearchRef.current?.focus()
    }
}, [mainSearchRef])

  const onInputText = (e: any) => {
    const str = e.target.value.trim();
    str?.length > 1 && dispatch(TagsActions.setSearchText(str));
    str?.length === 0 && dispatch(TagsActions.setSearchText(''));
  };

  const tagsScrollRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!tagsScrollRef.current) return;
    tagsScrollRef?.current?.scrollTo(0, 0)
  }, [headerTag, tagsScrollRef])

  const onTagSelect = (tag: any) => {
    const selected = selectedTagsIndex[tag.tagId];
    let v = innerValue;
    if (isTagEditor && !editableTags.includes(tag.tagId) && !(bProfile.isModer(profile) || bProfile.isSuperModer(profile))) {
      return;
    }
    if (!selected) {
      if (tag.level === 2 && isProjectEdit) {
        dispatch(TagsActions.setHeaderTag({ current: tag }));
        return;
      }
      const educationalTags = innerValue.filter(({ isEducationTag }: any) => isEducationTag);
      if (maxEducationalTags !== undefined && tag?.isEducationTag && educationalTags?.length + 1 > maxEducationalTags) {
        toasts.error(t('project_edit.max_required_tags_error'))
      } else {
        v = mode === 'link' || (max && innerValue?.length + 1 > max) ? [tag] : [...innerValue, tag];
      }
    } else if (protectedTags.includes(tag?.tagId)) {
      toasts.error("Это обязательный тег");
      return;
    } else {
      v = innerValue.filter((t) => t.tagId !== tag.tagId);
    }
    setInnerValue(v);
    
    if(tag.level === 2 && !isProjectEdit){
      dispatch(setIsOpen(true));
    }
  };

  const tagSearchSelection = (
    <TagsSearchSelection>
      <TagsSelectedTitle
        style={{ placeItems: 'center', whiteSpace: 'nowrap', marginBottom: 10 }}
      >
        {(!!innerValue.length && mode !== 'link') ? (isTagEditor ? `${t('tags_in_project')}:` : `${t('tags_modal.selected_tags')}:`) : t('tags_modal.select_tags')}
      </TagsSelectedTitle>
      {!!innerValue.length && (
        <AlignedBTagsGrid offsetTop={0}>
          <BTagsGridNew >
            {mode !== 'link' && innerValue.map((v: any) => (
              <BTag
                  tag={v}
                removable={true}
                key={v.tagId}
                // educational={v.isEducationTag}
                educational={isRequired(v)}
                //organization={isRequired(v, organizationEntity.tagIds, true)}
                organization={v?.isTeamTag}
                  showRemoveIcon={!(isTagEditor && !editableTags.includes(v.tagId) && !(bProfile.isModer(profile) || bProfile.isSuperModer(profile)))}
                  // @ts-ignore
                  disabled={isTagEditor && !editableTags.includes(v.tagId) && !(bProfile.isModer(profile) || bProfile.isSuperModer(profile))}
                  onIconClick={() => onTagSelect(v)}
              >
                {bTag.title(v)}
              </BTag>
            ))}
          </BTagsGridNew>
        </AlignedBTagsGrid>
      )}
    </TagsSearchSelection>
  );

  const getGrouping = () => {
    if (viewAllTags) {
      return 1;
    }
    const isSingleTag = tags?.length === 1;
    if (headerTag || isSingleTag) {
      return searchText ? 3 : 2;
    }
    if (!headerTag && searchText) {
      return 3;
    }
    return 1;
  };

  const displayedTags = useMemo(() => {
    if (viewAllTags) {
      return tags;
    }
    if (headerTag && !searchText) {
      return [
        {
          ...headerTag,
          additionalTags: tagMap[headerTag.tagId] || [],
        },
      ];
    }
    if (headerTag && searchText && tags.length) {
      return headerTag.level === 2 ? [tags[0]] : [tags[0]?.additionalTags?.[0]];
    }
    return tags.filter((tag: any) => !!tag?.additionalTags?.length);
  }, [tags, headerTag, viewAllTags, searchText, ungrouped, tagMap]);

  //Костыль чтобы убрать образовательную категорию и образов теги взависимости от открытой модалки
  const filteredTags = (arr: any[]) => {
      return arr;
  }

  const handleMoreClick = () => {
    setShowAllTagsInGroup(true);
  };

  const SearchResultsComponent = useMemo(() => <SearchResults
      tags={filteredTags(displayedTags)}
      grouping={getGrouping()}
      onTagSelect={onTagSelect}
      shouldVisibleEducationCategory={shouldVisibleEducationCategory}
      isMobileMenu={isMobileMenu}
      viewAllTags={viewAllTags}
      visible={!load}
      isEdit={isEdit}
      onMoreClick={handleMoreClick}
      showAllTagsInGroup={showAllTagsInGroup}
  >
    {!isMobileMenu && tagSearchSelection}
    {isTagEditor &&
        <TagsAvailableTitle
            style={{ display: 'inline-flex', placeItems: 'center', whiteSpace: 'nowrap' }}
        >
          {t('available_tags_in_project')}
        </TagsAvailableTitle>}
  </SearchResults>, [t, isTagEditor, isMobileMenu, tagSearchSelection, load, shouldVisibleEducationCategory, viewAllTags, onTagSelect, getGrouping, displayedTags, showAllTagsInGroup])
  return (
    <TagsSearchModalWrapper isMobileMenu={isMobileMenu}>
      <TagsSearchScrollWrapper ref={tagsScrollRef}>
      <TagsSearchModalContainer isMobileMenu={isMobileMenu}>
        {headerTag && <CategoryHeader headerTag={headerTag}/>}
        {!headerTag && !isMobileMenu && (
          <TagsSearchTitle color={theme.tagSearch.titleColor}>
            {t(isTagEditor ? "tag_editor" : max === 1 ? "select_single" : "select")}
            {isSuperPuper && <CloseIcon onClick={() => modal.hide()}/>}
          </TagsSearchTitle>
        )}
        <TagsSearchInputWrapper offsetTop={20} isMobileMenu={isMobileMenu}>
          <SearchIconWrapper isMobileMenu={isMobileMenu}>
            <Icon.Search24 />
          </SearchIconWrapper>
          <TagsSearchInput
            ref={mainSearchRef}
            onInput={debounceEvent(onInputText, 1000)}
            placeholder={t(isMobile ? "tags_modal.search_mobile" : "search")}
          />
        </TagsSearchInputWrapper>
        {isMobileMenu && (
          <InputSmallCaption>{t('select_tag_list')}</InputSmallCaption>
        )}
        {load && <EmptyTextWrapper directionMobile='column' gy={24}  width="100vw" align="center" justify="center" isMobileMenu={isMobileMenu}>
          <LoaderSpinner color={theme.selectContextModal.loaderText} text={t('project_edit.modal.load_msg_tag')}/>
        </EmptyTextWrapper>}

        {SearchResultsComponent}
      </TagsSearchModalContainer>
      </TagsSearchScrollWrapper>
      <ReactTooltip />
    </TagsSearchModalWrapper>
  );
};
